import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Grid
} from "@mui/material";

function TripTable({ trip }) {
  if (!trip) {
    return <p>No trip details available.</p>;
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Trip ID</TableCell>
            <TableCell>Trip Status</TableCell>
            <TableCell>Trip Title</TableCell>
            <TableCell>Trip Date</TableCell>
            <TableCell>Trip Time</TableCell>
            <TableCell>Service Associated</TableCell>
            <TableCell>Number of Persons</TableCell>
            <TableCell>Invoice Number</TableCell>
            <TableCell>Payment Mode</TableCell>
            <TableCell>Payment Status</TableCell>
            <TableCell>Payment Details</TableCell>
            <TableCell>Refund Details</TableCell>
            <TableCell>Rider Rating</TableCell>
            <TableCell>Driver Rating</TableCell>
            <TableCell>Final Amount</TableCell>
            {/* <TableCell>Created At</TableCell>
            <TableCell>Updated At</TableCell> */}
            <TableCell>Start OTP</TableCell>
            <TableCell>End OTP</TableCell>
            <TableCell>Cancelled By</TableCell>
            {/* <TableCell>Trip Thumbnail</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{trip._id}</TableCell>
            <TableCell>{trip.status || "N/A"}</TableCell>
            <TableCell>{trip.tripTitle || "N/A"}</TableCell>
            
            <TableCell>
              {new Date(trip.tripDate).toLocaleString() || "N/A"}
            </TableCell>
            <TableCell>
              {new Date(trip.tripTime).toLocaleString() || "N/A"}
            </TableCell>
            <TableCell>{trip.serviceAssociated || "N/A"}</TableCell>
            <TableCell>{trip.numberOfPersons || "N/A"}</TableCell>
            <TableCell>{trip.invoiceNumber || "N/A"}</TableCell>

            <TableCell>{trip.payment || "N/A"}</TableCell>
            <TableCell>{trip.paymentStatus || "N/A"}</TableCell>
            <TableCell>
              {trip.paymentDetails ? (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">
                      <strong>Amount:</strong> ₹{trip.paymentDetails.amount}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">
                      <strong>State:</strong> {trip.paymentDetails.state}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">
                      <strong>Response Code:</strong>{" "}
                      {trip.paymentDetails.responseCode}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">
                      <strong>Coupon Code:</strong>{" "}
                      {trip.paymentDetails.couponCode}
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  N/A
                </Typography>
              )}
            </TableCell>

            <TableCell>{trip.refundDetails || "N/A"}</TableCell>
            <TableCell>{trip.rider_rating || "N/A"}</TableCell>
            <TableCell>{trip.driver_rating || "N/A"}</TableCell>
            <TableCell>{trip.finalAmount || "N/A"}</TableCell>
            {/* <TableCell>{new Date(trip.created_at).toLocaleString() || 'N/A'}</TableCell>
            <TableCell>{new Date(trip.updated_at).toLocaleString() || 'N/A'}</TableCell> */}
            <TableCell>{trip.startOtp || "N/A"}</TableCell>
            <TableCell>{trip.endOtp || "N/A"}</TableCell>
            <TableCell>{trip.canclledBy || "N/A"}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TripTable;
